/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MissingWorkEntry } from '../../models/missing-work-entry';

export interface ApiV0MissingworkentryGetByCompanyGet$Json$Params {
  CompanyId?: string;
}

export function apiV0MissingworkentryGetByCompanyGet$Json(http: HttpClient, rootUrl: string, params?: ApiV0MissingworkentryGetByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MissingWorkEntry>>> {
  const rb = new RequestBuilder(rootUrl, apiV0MissingworkentryGetByCompanyGet$Json.PATH, 'get');
  if (params) {
    rb.query('CompanyId', params.CompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MissingWorkEntry>>;
    })
  );
}

apiV0MissingworkentryGetByCompanyGet$Json.PATH = '/api/v0/missingworkentry/getByCompany';
